module.exports = __webpack_public_path__ + "img/symbol_7.687c6111.png";